export default __webpack_public_path__ + "static/media/vivial_connect_logo.40350d4d.png";